import { useMotivation } from "@/hooks/useMotivation";
import StreakLevelCard from "./components/StreakLevelCard";
import BadgeGrid from "./components/BadgeGrid";
import StudyHeatmap from "./components/StudyHeatmap";
import ExamTrendChart from "./components/ExamTrendChart";

export default function MotivasyonPage() {
  const { data, loading, error, reload } = useMotivation();

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 tracking-tight">
          Motivasyon Merkezi
        </h1>
        <p className="text-sm md:text-base text-foreground-600 mt-1">
          Çalışma serin, seviyen, rozetlerin ve gelişimin — hepsi burada.
        </p>
      </div>

      {error && (
        <div className="rounded-lg border border-accent-200 bg-accent-50 p-4 flex items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <i className="ri-error-warning-line text-accent-700 text-xl" aria-hidden="true"></i>
            <div>
              <p className="text-sm font-semibold text-foreground-900">Veriler yüklenemedi</p>
              <p className="text-xs text-foreground-600">{error}</p>
            </div>
          </div>
          <button
            type="button"
            onClick={reload}
            className="whitespace-nowrap px-4 py-2 rounded-md bg-accent-500 text-background-50 text-sm font-semibold hover:bg-accent-600 transition-colors"
          >
            Tekrar Dene
          </button>
        </div>
      )}

      <StreakLevelCard data={data} loading={loading} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <StudyHeatmap heatmap={data.heatmap} loading={loading} />
        <ExamTrendChart trend={data.trend} loading={loading} />
      </div>

      <BadgeGrid badges={data.badges} loading={loading} />
    </div>
  );
}